import * as React from 'react';
import { I18n } from 'react-redux-i18n';

import { Loading } from '@common/components/loading';

import { TextEdit } from '../../../text-edit';
import { TextField } from '../../../text-field';
import { BackBtn } from '../../../back-btn';
import { Subtitle } from '../../../subtitle';

import { useFamilyBuilderPageController } from './family-builder-page.controller';
import { FamilyBuilderPageProps } from './family-builder-page.types';

import './family-builder-page.styles.scss';

export const FamilyBuilderPage: React.FC<FamilyBuilderPageProps> = (props) => {
  const { cachedData, onGoBack, errors } = props;

  const {
    loadingPage,
    handlePageNameChange,
    handlePageDescriptionChange,
  } = useFamilyBuilderPageController(props);
  
  if (loadingPage || !cachedData) {
    return (
      <div className="FhqDesignToolQuestionnaireDesignerPage">
        <Loading size={20} margin="20px" />
      </div>
    );
  }

  return (
    <div className="FhqDesignToolQuestionnaireDesignerFamilyBuilderPage">
      <BackBtn className="FhqDesignToolQuestionnaireDesignerFamilyBuilderPage__back-btn" onClick={onGoBack} />
      <TextEdit 
        errors={errors?.properties?.title}
        required
        metadata={{
          description: 'page-name',
        }}
        value={cachedData.title}
        onChange={handlePageNameChange}
      />
      <Subtitle type="chip" text={I18n.t('Build your family')} />
      <TextField 
        metadata={{
          description: 'page-description',
        }}
        type="textarea"
        classes={{
          label: 'FhqDesignToolQuestionnaireDesignerFamilyBuilderPage__description-label',
          labelInputWrapper: 'FhqDesignToolQuestionnaireDesignerFamilyBuilderPage__description-input-label-wrapper',
          input: 'FhqDesignToolQuestionnaireDesignerCousinPage__description-input'
        }}
        label={I18n.t('Page Description')}
        value={cachedData.description ?? ''}
        onChange={handlePageDescriptionChange}
      />
    </div>
  );
};